/**
 *Created by Heqi on 2018/1/25.
 */

import { AbstractSearchArgument } from './global'
import { CONDITION_TYPE, DATE_PICKER_SHOW_TYPE } from '@/utils/constants'

const FORM_LIST_SEARCH_CONDITION = [
  {
    name: 'time',
    title: '日期',
    placeholder: '',
    type: CONDITION_TYPE.DATE,
    value: '',
    visible: true,
    config: {
      type: DATE_PICKER_SHOW_TYPE.DATE_RANGE,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }
  },
  {
    name: 'itemId',
    title: '项目名称',
    placeholder: '请选择您的项目',
    type: CONDITION_TYPE.SELECT,
    value: '',
    visible: true,
    config: {
      list: []
    }
  }]

const SEARCH_CONDITION = [
  {
    name: 'time',
    title: '日期',
    placeholder: '',
    type: CONDITION_TYPE.DATE,
    value: '',
    visible: true,
    config: {
      type: DATE_PICKER_SHOW_TYPE.DATE_RANGE,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }
  },
  {
    name: 'itemId',
    title: '项目名称',
    placeholder: '请选择您的项目',
    type: CONDITION_TYPE.SELECT,
    value: '',
    visible: true,
    config: {
      list: []
    }
  }
]

class FeedbackSearchArgument extends AbstractSearchArgument {
  constructor () {
    super()

    this.startTime = ''
    this.endTime = ''
    this.itemId = ''
  }
}

export {
  SEARCH_CONDITION,
  FORM_LIST_SEARCH_CONDITION,
  FeedbackSearchArgument
}



// WEBPACK FOOTER //
// ./src/models/resource-count.js